// Port of api/fuel/app/classes/controller/api/monty/community/access.php
import PlatformEarly from 'offline/model/platform/early'

export default function(params) {
	var method = params.__offlineMethod || 'GET'

	if (method !== 'GET') {
		return Promise.reject({ error: 'This action is not available offline.', offline: true })
	}

	var items = PlatformEarly.collection({
		where: [
			['early_status', '<', 3]
		],
		order_by: 'early_status ASC, early_name ASC'
	}).map(function(item) {
		return item.to_array()
	})

	return Promise.resolve({
		session: { offline: true },
		data: {
			items: items
		}
	})
}
